import App from 'app/app.js';
import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';

function LtWelcomeCtrl($scope, UserProfileStore, $timeout) {
  LtSelectionDrawerCtrl.call(this, $scope, $timeout);

  this.loginCtrlMethod = function () {
    $scope.onContinue();
  };

  this.cancelMethod = function () {
    UserProfileStore.userProfile.isLoggedIn = false;
    UserProfileStore.userProfile = {};
    UserProfileStore.updateStorage();
    $scope.onCancel();
  };
}

App.controller('LtWelcomeCtrl', ['$scope', 'UserProfileStore', '$timeout', LtWelcomeCtrl]);
